// Launch gate (setter spec §10.1–§10.3, §13.2): per-project «Salida a producción» checklist, dual approval, pause /
// resume, Level B change requests and the workspace's designated approvers. Schemas in launch.ts. Shared by every module.
import * as L from './launch.js';
import { IdParam, items, route, W, Ws } from './route-def.js';

const P = W({ projectId: IdParam });

export const launchRoutes = {
  getProjectLaunch: route({
    method: 'GET', path: '/workspaces/:workspaceId/projects/:projectId/launch', summary: 'Salida a producción: checklist, aprobaciones y cambios pendientes', tag: 'launch',
    minRole: 'manager', module: null, params: P, response: L.ProjectLaunchSchema,
  }),
  updateLaunchItem: route({
    method: 'PUT', path: '/workspaces/:workspaceId/projects/:projectId/launch/items/:itemKey', summary: 'Marcar un punto del checklist con evidencia', tag: 'launch',
    minRole: 'admin', module: null, params: W({ projectId: IdParam, itemKey: L.LaunchItemKeySchema }), body: L.UpdateLaunchItemSchema, response: L.ProjectLaunchSchema,
  }),
  submitProjectLaunch: route({
    method: 'POST', path: '/workspaces/:workspaceId/projects/:projectId/launch/submit', summary: 'Enviar a aprobación (checklist completo)', tag: 'launch',
    minRole: 'admin', module: null, params: P, response: L.ProjectLaunchSchema,
  }),
  withdrawProjectLaunch: route({
    method: 'POST', path: '/workspaces/:workspaceId/projects/:projectId/launch/withdraw', summary: 'Regresar a preparación (anula las aprobaciones de la ronda)', tag: 'launch',
    minRole: 'admin', module: null, params: P, body: L.LaunchReasonSchema, response: L.ProjectLaunchSchema,
  }),
  approveProjectLaunch: route({
    method: 'POST', path: '/workspaces/:workspaceId/projects/:projectId/launch/approve', summary: 'Registrar la aprobación comercial o técnica', tag: 'launch',
    minRole: 'admin', module: null, params: P, body: L.ApproveLaunchSchema, response: L.ProjectLaunchSchema,
  }),
  pauseProject: route({
    method: 'POST', path: '/workspaces/:workspaceId/projects/:projectId/launch/pause', summary: 'Pausar la atención de prospectos reales', tag: 'launch',
    minRole: 'admin', module: null, params: P, body: L.LaunchReasonSchema, response: L.ProjectLaunchSchema,
  }),
  resumeProject: route({
    method: 'POST', path: '/workspaces/:workspaceId/projects/:projectId/launch/resume', summary: 'Reanudar (si la configuración no cambió desde la aprobación)', tag: 'launch',
    minRole: 'admin', module: null, params: P, body: L.LaunchReasonSchema, response: L.ProjectLaunchSchema,
  }),
  approveChangeRequest: route({
    method: 'POST', path: '/workspaces/:workspaceId/change-requests/:changeRequestId/approve', summary: 'Aprobar un cambio de nivel B', tag: 'launch',
    minRole: 'admin', module: null, params: W({ changeRequestId: IdParam }), body: L.ApproveChangeRequestSchema, response: L.ChangeRequestSchema,
  }),
  rejectChangeRequest: route({
    method: 'POST', path: '/workspaces/:workspaceId/change-requests/:changeRequestId/reject', summary: 'Rechazar un cambio de nivel B', tag: 'launch',
    minRole: 'admin', module: null, params: W({ changeRequestId: IdParam }), body: L.LaunchReasonSchema, response: L.ChangeRequestSchema,
  }),
  listChangeRequests: route({
    method: 'GET', path: '/workspaces/:workspaceId/change-requests', summary: 'Cambios de nivel B pendientes y recientes', tag: 'launch',
    minRole: 'manager', module: null, params: Ws, response: items(L.ChangeRequestSchema),
  }),
  getLaunchApprovers: route({
    method: 'GET', path: '/workspaces/:workspaceId/launch-approvers', summary: 'Responsables de la aprobación comercial y técnica', tag: 'launch',
    minRole: 'admin', module: null, params: Ws, response: L.LaunchApproversSchema,
  }),
  putLaunchApprovers: route({
    method: 'PUT', path: '/workspaces/:workspaceId/launch-approvers', summary: 'Designar responsables de aprobación', tag: 'launch',
    minRole: 'owner', module: null, params: Ws, body: L.PutLaunchApproversSchema, response: L.LaunchApproversSchema,
  }),
};
